import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import WhyChooseSection from './components/WhyChooseSection';
import CategoriesSection from './components/CategoriesSection';
import SafetySection from './components/SafetySection';
import ArticlesGridSection from './components/ArticlesGridSection';
import ArticleCTASection from './components/ArticleCTASection';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://kakobuypolska.beer';

  const jsonLdWebSite = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'KakobuyPolska',
    url: siteUrl,
    description: 'Największy polski przewodnik Kakobuy Spreadsheet. Znajdź sneakersy, ubrania, akcesoria i najlepsze produkty z Chin.',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteUrl}/?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  const jsonLdOrg = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'KakobuyPolska',
    url: siteUrl,
    description: 'Największy polski przewodnik Kakobuy Spreadsheet',
  };

  const jsonLdBreadcrumb = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Strona główna', item: `${siteUrl}/` },
    ],
  };

  const jsonLdFaq = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'Czy Kakobuy Spreadsheet jest darmowy?',
        acceptedAnswer: { '@type': 'Answer', text: 'Tak, większość arkuszy Kakobuy Spreadsheet jest dostępna za darmo. Podstawowe kategorie są ogólnodostępne dla wszystkich użytkowników.' },
      },
      {
        '@type': 'Question',
        name: 'Jak długo trwa wysyłka z Kakobuy do Polski?',
        acceptedAnswer: { '@type': 'Answer', text: 'Standardowy czas dostawy do Polski wynosi od 10 do 25 dni roboczych, w zależności od wybranej metody wysyłki.' },
      },
      {
        '@type': 'Question',
        name: 'Czy Kakobuy jest bezpieczny dla kupujących z Polski?',
        acceptedAnswer: { '@type': 'Answer', text: 'Tak, Kakobuy oferuje program ochrony kupującego, zdjęcia QC i bezpieczne metody płatności. Zawsze warto dodatkowo weryfikować sprzedawców.' },
      },
      {
        '@type': 'Question',
        name: 'Ile kosztuje wysyłka Kakobuy do Polski?',
        acceptedAnswer: { '@type': 'Answer', text: 'Koszt wysyłki zależy od wagi paczki i metody dostawy. Dla standardowej paczki do 1 kg koszt wynosi około 80-150 PLN.' },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdWebSite) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdOrg) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdBreadcrumb) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdFaq) }} />
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <WhyChooseSection />
        <CategoriesSection />
        <ArticlesGridSection />
        <SafetySection />
        <ArticleCTASection />
      </main>
      <Footer />
    </>
  );
}